module.exports = global.config = {    
    API_URL: "http://wholesale.yasini.com/api"
   // API_URL: "http://localhost:5000"
};